import useRouter from '../../../hooks/useRouter'
import { useState } from 'react'
import { TABS_OPTIONS } from './constants'
import RadioGroup from '../../../components/RadioGroup/RadioGroup'
import { TABS_OPTIONS_KEY } from '../MyOrganization/constants'
import { CommonsUsers } from './Users/Users'

export const MyOrganizationCommons = () => {
  const { query, push } = useRouter()
  const [activeSubTab, setActiveSubTab] = useState(
    query?.type || TABS_OPTIONS[0].value
  )
  const handleTabs = (e) => {
    setActiveSubTab(e)
    push(e)
  }

  return (
    <div className="my-organisation-container">
      <RadioGroup.Buttons
        options={TABS_OPTIONS}
        defaultValue={activeSubTab}
        onChange={handleTabs}
        className="mt-0 mb-24"
      />
      {activeSubTab === TABS_OPTIONS_KEY.users && <CommonsUsers />}
    </div>
  )
}
